import React, { useState } from 'react';
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  FormControl,
  FormLabel,
  Row,
} from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { FormFeedback } from 'reactstrap';
import classnames from 'classnames';
import { useParams } from 'react-router-dom';
import { currentYear, appName } from '../common/helpers';
import PageMetaData from '../common/components/pageMetaData/PageMetaData';
import HorizontalLogo from '../common/components/logo/HorizontalLogo';
import { resetPassword } from '../auth/AuthActions';
import validationSchema from '../auth/resetpassword/ResetPasswordForm.schema';

function ResetPasswordLayout() {
  const [password, setPassword] = useState('');
  const [passwordRepeat, setPasswordRepeat] = useState('');
  const [errors, setErrors] = useState({});
  const { token } = useParams();

  const dispatch = useDispatch();

  const handleRecoverPassword = () => {
    setErrors({});
    validationSchema
      .validate(
        {
          password,
          passwordRepeat,
        },
        { abortEarly: false },
      )
      .then(() => {
        dispatch(
          resetPassword({ password, passwordRepeat, token }, () => {
            setPassword('');
            setPasswordRepeat('');
          }),
        );
      })
      .catch((validation) => {
        const err = {};
        validation.inner.forEach((e) => {
          err[e.path] = e.message;
        });

        setErrors({
          ...err,
        });
      });
  };

  return (
    <>
      <PageMetaData title="Reset Password" />
      <div
        className="auth-box overflow-hidden align-items-center d-flex"
        style={{ minHeight: '100vh' }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col xxl={4} md={6} sm={8}>
              <div className="auth-brand text-center mb-4">
                <HorizontalLogo />
                <h4 className="fw-bold mt-3">Reset Your Password</h4>
              </div>

              <Card className="p-4 rounded-4">
                <Form>
                  <div className="mb-3 form-group">
                    <FormLabel>
                      Password <span className="text-danger">*</span>
                    </FormLabel>
                    <FormControl
                      type="password"
                      placeholder="••••••••"
                      className={classnames('form-control', errors.password && 'is-invalid')}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    {errors?.password && <FormFeedback>{errors.password}</FormFeedback>}
                  </div>

                  <div className="mb-3 form-group">
                    <FormLabel>
                      Repeat Password <span className="text-danger">*</span>
                    </FormLabel>
                    <FormControl
                      type="password"
                      placeholder="••••••••"
                      className={classnames(
                        'form-control',
                        errors.passwordRepeat && 'is-invalid',
                      )}
                      onChange={(e) => setPasswordRepeat(e.target.value)}
                    />
                    {errors?.passwordRepeat && (
                      <FormFeedback>{errors.passwordRepeat}</FormFeedback>
                    )}
                  </div>

                  <div className="d-grid">
                    <Button
                      className="rounded-pill btn-primary fw-semibold py-2"
                      onClick={() => handleRecoverPassword(password, token, resetPassword)}
                    >
                      Reset Password
                    </Button>
                  </div>
                </Form>
              </Card>

              <p className="text-center text-muted mt-4 mb-0">
                © {currentYear} <span className="fw-semibold">{appName}</span>
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default ResetPasswordLayout;
